import { render, staticRenderFns } from "./CreateBranch.vue?vue&type=template&id=c75f675e&scoped=true&"
import script from "./CreateBranch.vue?vue&type=script&lang=js&"
export * from "./CreateBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75f675e",
  null
  
)

export default component.exports